const root = 'subscriptionPlan'

export const TestId = {
  root,
  card: tier => `${root}-${tier}`,
  upgradeActionButton: `${root}-upgradeActionButton`,
  currentPlanChip: `${root}Card-currentPlanChip`,
}
